@for (page of pages(); track page) {
  <div class="pdf-page" (click)="switchPage.emit($index)" [class.active]="activePage() === $index">
    <div class="page-number">{{ $index + 1 }}</div>
    @let version_data = version();
    <div class="image-container">
      <img
        [width]="page.width"
        [height]="page.height"
        loading="lazy"
        [src]="
          version_data
            | assetVersionUrl
              : asset()
              : version_data.status
              : 170
              : 170
              : asset().watermark_enabled && !!gallery().watermark
              : undefined
              : $index
        "
        alt=""
      />
    </div>
  </div>
}
